import React, {
  useEffect,
  useState
} from "react";


import {
  Box,
  Typography,
  CircularProgress
} from "@mui/material";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";


import {
  getPriorityReport
} from "../../services/reportService";
import uiConfig from "../../config/uiConfig";






function PriorityChart({ departmentId = null }){



const [data,setData] = useState([]);

const [loading,setLoading] = useState(true);







useEffect(()=>{


const loadPriority = async()=>{


try{


const response = await getPriorityReport(departmentId);


setData(response);



}

catch(error){


console.error(

"Priority Report Error:",

error

);


}

finally{


setLoading(false);


}


};



loadPriority();


},[departmentId]);










if(loading){


return (

<Box

height="100%"

display="flex"

justifyContent="center"

alignItems="center"

>

<CircularProgress/>

</Box>

);


}









return (


<Box

height="100%"

>





<Typography

sx={{

fontSize:14,

fontWeight:600,

color:"text.primary",

mb:2

}}

>

Priority Analysis

</Typography>









<ResponsiveContainer

width="100%"

height={250}

>


<BarChart

data={data}

barSize={32}

>




<CartesianGrid

strokeDasharray="3 3"

vertical={false}

/>







<XAxis

dataKey="priority"

fontSize={12}

/>







<YAxis

fontSize={12}

/>







<Tooltip />







<Bar

dataKey="tickets"

fill={uiConfig.chartPrimaryColor}

radius={[6,6,0,0]}

/>






</BarChart>


</ResponsiveContainer>







</Box>


);


}



export default PriorityChart;